const name = '.spectral.yaml'
const text = `extends: ["spectral:oas", "spectral:asyncapi"]
`
const template = { name, text }
export default template
